import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import { createStore } from 'satcheljs';
import ReadingPaneStore from './schema/ReadingPaneStore';

const initialReadingPaneStore: ReadingPaneStore = {
    conversationReadingPaneViewState: null,
    floatingActionBarViewState: {
        isVisible: false,
        itemId: '',
    },
    itemReadingPaneViewState: null,
    itemPreviewPaneViewState: null,
    itemPrintPaneViewState: null,
    deeplinkId: null,
};

export let getStore = createStore<ReadingPaneStore>('readingpane', initialReadingPaneStore);
const store = getStore();

// Register the reading pane conversation with the conversation cache
conversationCache.registerReference(
    () =>
        store.conversationReadingPaneViewState &&
        store.conversationReadingPaneViewState.conversationId.Id
);

export default store;
